export default class TeamView extends Backbone.View {

    events() {
        return {
            "click .arrow-left": "slideRight",
            "click .arrow-right": "slideLeft",
            "click .face": "getFace"
        }
    }

    initialize(options) {
        this.$faces = this.$el.find(".faces");
        this.length = this.$el.find(".faces .face").length;
        this.$box = this.$el.find(".box");
        this.blocked = false;
        this.pos = this.$faces.find(".selected").index();
        this.getBoundings();
        this.buildStage();
        $(window).resize(this.resize.bind(this));
        this.render();
    }
    block() {
        this.blocked = true;
    }
    unblock() {
        this.blocked = false;
    }
    getFace(event) {
        event.preventDefault();
        var $face;
        if (!$(event.target).hasClass("face")) {
            $face = $(event.target).closest(".face");
        } else {
            $face = $(event.target).closest(".face");
        }
        let curIndex = $face.index(),
            delta = curIndex - this.pos;
        this.right += (this.faceWidth + this.faceMargin) * delta;
        this.pos = curIndex;
        this.buildStage(delta);
    }

    getFaceEl(index) {
        let limit = this.$faces.find(".face").length;
        if (index < 0) {
            index = limit - (Math.abs(index)-(Math.floor(Math.abs(index)/limit)*limit));
        } else {
            index = (index-(Math.floor(index/limit)*limit));
        }
        return this.$faces.find(`.face:eq(${index})`);
    }

    centerFace(index) {
        this.changePos(index, ((this.stageWidth / 2) - (this.selectedFaceWidth / 2)) );
        var $selected = this.getFaceEl(index);
        this.$box.find(".name span").fadeOut(150, function(){
            $(this).text($selected.find(".name").text());
            $(this).fadeIn(150);
        });
        this.$box.find(".position span").fadeOut(150, function(){
            $(this).html($selected.find(".position").html());
            $(this).fadeIn(150);
        });
        this.$box.find(".email span").fadeOut(150, function(){
            $(this).text($selected.find(".email").text());
            $(this).parent("a").attr("href", $selected.find(".email").attr("href")).attr("title", $selected.find(".email").attr("title"));
            $(this).fadeIn(150);
        });
        this.$box.find(".phone span").fadeOut(150, function(){
            var selected = $selected.find(".phone");
            $(this).parent("a").attr("href", selected.attr("href"));
            $(this).parent("a").attr("title", selected.attr("title"));
            $(this).text(selected.text());
            $(this).fadeIn(150);
        });
    }

    changePos(faceIndex, left) {
        let $el = this.getFaceEl(faceIndex);
        if (!$el) {
            return;
        }
        let pos = parseInt($el.css('left')) ;
        let multiplier = this.stageWidth < 300 ? 2 : 4;
        if (Math.abs(pos - left) > (this.selectedFaceWidth*multiplier + (this.faceMargin * multiplier))) {
            if (left < this.stageWidth / 2) {
                $el.css("left", (0 - this.faceWidth - this.faceMargin) + "px");
            } else {
                $el.css("left",  (this.faceWidth + this.faceMargin + this.stageWidth) + "px");
            }
        }
        this.block();
        this.getFaceEl(faceIndex).stop().animate({"left": left + "px"}, 400, this.unblock.bind(this));
    }

    placeFaceAtPos(faceIndex, pos) {
        let left,
            halfStage = (this.stageWidth / 2);
        if (pos > 2) {
            left = halfStage + (this.boxWidth / 2) + this.faceMargin + ((pos - 4) * (this.faceWidth + this.faceMargin));
        } else {
            left = halfStage - (this.boxWidth / 2)  - ((3 - pos) * (this.faceMargin + this.faceWidth));
        }
        this.changePos(faceIndex, left);
    }

    slideLeft(e) {
        e.preventDefault();
        if (this.blocked) {
            return;
        }
        this.pos += 1;
        this.buildStage(1);
    }

    slideRight(e) {
        e.preventDefault();
        if (this.blocked) {
            return;
        }
        this.pos -= 1;
        this.buildStage(-1);
    }

    hideRight(faceIndex) {
        this.changePos(faceIndex, (this.stageWidth + this.faceWidth + this.faceMargin));
    }

    hideLeft(faceIndex) {
        this.changePos(faceIndex, (0 - this.faceWidth - this.faceMargin));
    }

    getBoundings() {
        this.stageWidth = parseInt(this.$el.find(".team-content").width());
        this.boxWidth = parseInt(this.$el.find(".box").width());
        this.faceWidth = parseInt(this.$el.find(".faces .face:first").css("width"));
        this.selectedFaceWidth = parseInt(this.$el.find(".faces .face.selected").css("width"));
        this.faceMargin = 20;
    }

    resize() {
        let prevStage = this.stageWidth;
        this.getBoundings();
        if (prevStage != this.stageWidth) {
            this.buildStage();
        }
    }

    buildStage(change) {
        if (change < -2) {
            change = -2;
        } else if (change > 2) {
            change = 2
        }
        let $selected = this.$el.find(".face.selected");
        $selected.addClass('post-selected').removeClass('selected');
        setTimeout(function () {
            $selected.removeClass('post-selected')
        }, 500);
        this.getFaceEl(this.pos).addClass('selected');
        this.centerFace(this.pos);

        for (let i of [1, 2, 4, 5]){
            let elIndex = this.pos + (-3+i);
            this.placeFaceAtPos(elIndex, i);
        }

        for (let i of [3, 4]){
            this.hideLeft(this.pos-i);
            this.hideRight(this.pos+i);
        }
    }

    render() {
        // this.$faces.css("width", (this.length * (this.faceWidth + this.faceMargin) + (185 * 2)) + "px");
        this.$el.find('.slider').css('opacity', 1);
    }
}



// WEBPACK FOOTER //
// ./frontend/js/views/team.js